<div class="how-works modal">
    <div class="modal-header">
        <h1>{{ 'creditLetter.howWorksModal.title' | translate }}</h1>
        <mat-icon class="close" mat-dialog-close>close</mat-icon>
    </div>

    <div class="text-container">
        <p [innerHTML]="'creditLetter.howWorksModal.text' | translate"></p>
    </div>

    <div class="modal-buttons">
        <button (click)="askQuestions()" *ngIf="enableContactButton" mat-flat-button class="btn outlined">{{ 'creditLetter.howWorksModal.askQuestions' | translate }}</button>
        <button [disabled]="loading" mat-flat-button class="btn default" mat-dialog-close>{{ 'creditLetter.howWorksModal.okClose' | translate }}</button>
    </div>
    <mat-progress-spinner *ngIf="loading" class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
</div>